import React, {Component} from 'react';
import ReactSlider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {maybe} from '../utils';

export default class Slider extends Component {
    render() {
        const {rangeMarks, min, max} = this.props;
        let marks;
        if (rangeMarks) {
            marks = {};
            const {start, end, step} = rangeMarks;
            for (let i = maybe(start, min), iEnd = maybe(end, max); i <= iEnd; i += step) {
                marks[i] = i;
            }
        }
        return (
            <ReactSlider dots={false} marks={marks} {...this.props}/>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Slider.js